import { render, staticRenderFns } from "./DispatchCustomerModal.vue?vue&type=template&id=151d64f4&scoped=true"
import script from "./DispatchCustomerModal.vue?vue&type=script&lang=js"
export * from "./DispatchCustomerModal.vue?vue&type=script&lang=js"
import style0 from "./DispatchCustomerModal.vue?vue&type=style&index=0&id=151d64f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151d64f4",
  null
  
)

export default component.exports